export const parseDate = (s:string) => {
  const b:number[] = s.split(/\D/).map( v=> parseInt(v))
  return new Date(b[0],b[1]-1,b[2],b[3],b[4],b[5]);
}